import { Routes, Route} from 'react-router-dom';

import Home from './pages/Home/Home.js';
import LogIn from './pages/LogIn/LogIn.js';
import MyPage from './pages/MyPage/MyPage.js';
import Shop from './pages/Shop/Shop.js';
import Detail from './pages/Detail/Detail.js';
import Cart from './pages/Cart/Cart.js';
import Sell from './pages/Sell/Sell.js';
import About from './pages/About/About.js';
import Event from './pages/Event/Event.js';

import useScrollToTop from './hooks/useScrollToTop.js';

import Navbar from './components/Navbar/Navbar.js';
import Footer from './components/Footer/Footer.js';

function App() {
  useScrollToTop();

  return (
    <div className="App">
      <Navbar></Navbar>

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LogIn />} />
        <Route path="/mypage" element={<MyPage />} />
        <Route path="/sell" element={<Sell />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:id" element={<Detail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/about" element={<About />} />
        <Route path="/event" element={<Event />} />
      </Routes>

      <Footer></Footer>
    </div>
  );
}

export default App;